import { type Currency, DEFAULT_CURRENCY } from "@loot-os/api-contract";
import { createContext, useContext } from "react";

/** The storefront's currency (`StorefrontConfig.currency`), for every amount below it. */
export const CurrencyContext = createContext<Currency>(DEFAULT_CURRENCY);

/** The currency amounts below a CurrencyProvider render in. */
export function useCurrency(): Currency {
  return useContext(CurrencyContext);
}
